import axios from 'axios'
const CART = `/functions/cart_total.php`
/**
controlli checkout
 */

//const payment = document.getElementsByName('radio-group-payments')
const paese = document.getElementById('billing:country_id')
const paeseSpedizione = document.getElementById('shipping:country_id')
const orderSubmit = document.getElementById('order-submit')
const newAddress = document.querySelector('.j-new-address-togglr')
const newAddressForm = document.querySelector('.j-new-address')
const idShipping = document.getElementById('shipping-address-id')
const addressList = document.getElementById('lista-indirizzi-spedizione')
const addressCheckbox = document.querySelectorAll('.j-shipping-address__checkbox')
const newAddressFields = document.querySelectorAll('.j-shipping-new-address')
const msg = document.querySelector('.j-address-country-msg')
const shippingMsg = document.querySelector('.shipping-msg')
const paymentMsg = document.querySelector('.j-payment-msg')
const shipToDifferent = document.getElementById('use_for_shipping')

const updateShipping = (element) => {
	
	const loader = document.querySelector('.j-cart-discount-loader')
	const cartAside = document.querySelector('.j-checkout-aside')
	const position = element.target.dataset.position
	
	var region = document.querySelector('.j-' + position + '-region-wrapper')

	if(loader) {
		loader.classList.add('is-active')
	}
	
	msg.classList.add('c-form-error')

	axios.get(CART, {
		params: {
			lang: window.motostorm.lang,
			country: element.target.value,
			position: position
		},
	})
	.then(resp => {

		cartAside.innerHTML = resp.data.checkout
		if(region){
			region.innerHTML = resp.data.region
		}
		if(loader){
			loader.classList.remove('is-active')
		}
		
		if(position == 'billing'){
			location.href = location.href
		}		

	})
	.catch(err => {
		// Handle Error Here
		console.error(err)
	})	
}

const Shipping = (id) => {
	
	const loader = document.querySelector('.j-cart-discount-loader')
	const cartAside = document.querySelector('.j-checkout-aside')
	
	idShipping.value = id
	
	if(loader) {
		loader.classList.add('is-active')
	}
	
	newAddressForm.classList.remove('is-active')
	newAddressForm.style.display = 'none'
	shippingMsg.classList.remove('is-active')

	axios.get(CART, {
		params: {
			lang: window.motostorm.lang,
			shippingId: id
		},
	})
	.then(resp => {

		cartAside.innerHTML = resp.data.checkout
		if(loader){
			loader.classList.remove('is-active')
		}

	})
	.catch(err => {
		// Handle Error Here
		console.error(err)
	})
	
}

const openNewAddress = (element) => {
	
	const addressList = document.getElementById('lista-indirizzi-spedizione')
	
	if(addressCheckbox){
		addressCheckbox.forEach((item, key) => {
			if(newAddressForm.classList.contains('is-active')){
				item.checked = false
				item.required = false
			} else {
				item.required = true
			}
		})
	}
	
	if(addressList){
		addressList.value = 0
		addressList.required = false
		//idShipping.value = 0
	}
	
	//paeseSpedizione.value = ''
	idShipping.value = 0
	msg.classList.remove('c-form-error')

}

const invioOrdine = (event) => {

	//event.target.disabled = true // NON disabilitare per evitare problemi con IOS
	
	if( addressList && addressList.required == true && addressList.value == 0){
		
		event.preventDefault()
		shippingMsg.classList.add('is-active')
		document.querySelector('.j-address').scrollIntoView()
		return false // stoppa la funzione
		
	}
	
	if(addressCheckbox){
		var checked = false
		var required = false
		addressCheckbox.forEach(item => {
			if(item.required == true){
				required = true
			}			
			if(item.checked == true){
				checked = true
			}
		})
		
		if(required == true && checked == false){
			event.preventDefault()
			shippingMsg.classList.add('is-active')
			document.querySelector('.j-address').scrollIntoView()
			//return false // stoppa la funzione
		}
	}
	
	//CONTROLLO SE C'è IL PAGAMENTO
	if(paymentMsg){
		// controllo pagamento
		const selectedPayment = document.querySelector('input[name="Pagamento"]:checked');
		
		if (!selectedPayment) {
			event.preventDefault()
			paymentMsg.classList.add('is-active')
			paymentMsg.scrollIntoView()
		}
	}
	// Puoi proseguire con l'invio del form o altre azioni
}

const eventCheckbox = (element) => {

	var id = element.target.value
	Shipping(id)
	if( newAddressFields ) {
		newAddressFields.forEach( item => {
			item.required = false
		})
	}
}

const toggleShipToDifferent = () => {

	if( newAddressForm.classList.contains('is-active') ){
		location.href = location.href
	}
}

// Aggiungi evento cambio paese
if ( paese ) {
	paese.addEventListener('change', updateShipping)
}

// Aggiungi evento cambio indirizzo da lista
if ( addressList ) {
	addressList.addEventListener('change', function() {
		Shipping(addressList.value)
		if( newAddressFields ) {
			newAddressFields.forEach( item => {
				item.required = false
			})
		}
	})	
}

// Se cambio il paese di destinazione nell'indirizzo di spedizione
if ( paeseSpedizione ) {
	paeseSpedizione.addEventListener('change', updateShipping)
}

// apro/chiudo form nuovo indirizzo spedizione
if( newAddress ) {
	newAddress.addEventListener('click', openNewAddress)
}

// click su checkbox indirizzo
if( addressCheckbox ) {
	addressCheckbox.forEach( item => {
		item.addEventListener('click', eventCheckbox)
	})
}

// controlli all'invio dell'ordine
if( orderSubmit ){
	orderSubmit.addEventListener('click', invioOrdine)
}

// spedizione ad indirizzo diverso checkbox
if( shipToDifferent ){
	shipToDifferent.addEventListener('click', toggleShipToDifferent)
}

const storeData  = (element) => {

	sessionStorage.setItem(element.target.dataset.store, element.target.value)
}

const initStoreData  = () => {
	
	const storeFields = document.querySelectorAll('.j-store')
	
	storeFields.forEach( item => {
		
		item.addEventListener('blur', storeData)
		
		var storedValue = sessionStorage.getItem(item.dataset.store)

		if (storedValue !== null) item.value = storedValue
	})
	
}

if(paese) {
	initStoreData()
}